// Basic
import { useEffect } from 'react';
// Store & actions
import useRemoteCollectionStore from '@/app/store/modules/remoteCollection';
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsRemoteCollections from '../../api/actionsRemoteCollections';
// Components
import RenderInternationalizedAmount from '@/common-utils/components/renders/currency/RenderInternationalizedAmount';
import { Skeleton } from '@/common-utils/components/ui/skeleton';
// Common
import remoteCollectionFields from '../../fields/remoteCollectionFields';

/**
 * @returns {JSX} RemoteCollectionsTotalRevenue
 */
function RemoteCollectionsTotalRevenue() {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const query = useRemoteCollectionStore(s => s.query);
    const filters = useRemoteCollectionStore(s => s.query.filters);

    // API call
    const { data: totalRevenue, isFetching, refetch } = actionsRemoteCollections.getTotalRevenue(query, false);

    // Hooks
    useEffect(() => {
        if (rootOrganization && query) {
            refetch();
        }
    }, [query, filters, rootOrganization]);

    if (isFetching) {
        return (
            <div className='flex items-center'>
                <Skeleton className='h-8 w-40 rounded-lg' />
            </div>
        );
    }

    if (!totalRevenue) {
        return null;
    }

    // Constants
    const amount = totalRevenue[remoteCollectionFields.TOTAL_REVENUE.key];

    return (
        <div className='flex items-center'>
            <RenderInternationalizedAmount
                amount={amount}
                currency={totalRevenue[remoteCollectionFields.CURRENCY.key] ?? 'EUR'}
                namespace={remoteCollectionFields.TOTAL_REVENUE.namespace}
                additionalText={remoteCollectionFields.TOTAL_REVENUE.entity}
                isRemoteCollectionEmpty={amount === 0}
                spanClassName='px-1 h-8 rounded-lg shadow-md border content-center'
            />
        </div>
    );
}

export default RemoteCollectionsTotalRevenue;
